// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gxwcz","left":"styles_left__3q2S_","desktopActions":"styles_desktopActions__1is9G","title":"styles_title__3W45l"};